const NAMESPACE = 'STATION_DATA';

const SET_STATION_DETAILS = `${NAMESPACE}/SET_STATION_DETAILS`;

export {
    SET_STATION_DETAILS,
};

export default NAMESPACE;
